import { observer, useLocalObservable } from "mobx-react";
import { Modal, Typography, Input, Tag, Checkbox } from "antd";
import { translateKey as t } from "../../../../../../locales/translation";
import { ClientsController } from "../../../ClientsController";
import { AppStore } from "~/stores/AppStore";
import { useEffect } from "react";
const { Title } = Typography;

const ResetMasterDataModal = observer(({ store, controller }: { store?: AppStore; controller?: ClientsController }) => {
  useEffect(() => {});

  const state = useLocalObservable(() => ({
    deleteText: "",

    setDeleteText(value: string) {
      this.deleteText = value;
    },
  }));

  const handleOK = () => {
    const { row } = controller?.resetMasterDataModal;
    state.setDeleteText("");
    controller.resetMasterData(row.vertical, row.demo);
  };

  const handleCancel = () => {
    store.clearClient();
    state.setDeleteText("");
    controller.setResetMasterDataModal(null, {
      visible: false,
      loading: false,
      row: null,
    });
  };

  if (!controller.resetMasterDataModal.visible) {
    return null;
  }

  const { row } = controller?.resetMasterDataModal;
  let foundVertical = controller.verticals.find((vl) => vl.ref === row.proOptions.vertical);

  return (
    <Modal
      title={"Reset Master Data: " + controller?.resetMasterDataModal?.row?.name}
      open={controller.resetMasterDataModal.visible}
      cancelText={t("lblCancel", "Cancel")}
      okText={t("lblResetMasterData", "Reset Master Data")}
      centered={true}
      okType="danger"
      okButtonProps={{ disabled: state.deleteText !== "reset" }}
      onOk={handleOK}
      onCancel={handleCancel}
    >
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "space-around" }}>
        <Title level={4} style={{ width: "max-content", alignSelf: "center" }}>
          {t("lblAreYouSure", "Are you sure?")}
        </Title>

        <strong style={{ alignSelf: "center" }}>{t("lblThisProcessCannotBeReversed", "This process cannot be reversed.")}</strong>

        <div className="flex justify-center items-center mt-4">
          <div>
            <Tag bordered={false} color="processing">
              {foundVertical?.description || "N/A"}
            </Tag>
          </div>
          {/* <div>
            <Checkbox checked={row.demo}>Demo</Checkbox>
          </div> */}
        </div>

        <Input
          data-e2e="delete-modal-confirm-deletion"
          onChange={(e) => state.setDeleteText(e.target.value)}
          value={state.deleteText}
          maxLength={20}
          size="small"
          style={{ marginTop: "20px" }}
          placeholder={t("lblTypeInResetToConfirmDeletion", 'Type in "reset" to confirm Master Data Reset')}
          autoComplete="newpassword"
        ></Input>
      </div>
    </Modal>
  );
});

export default ResetMasterDataModal;
